import type { SortOption } from '@/components/common/filter';

/**
 * 커뮤니티 글 목록(속닥속닥·전문가 라운지) 정렬 — 서버 `sort` 값과 같다(core ContentListSort).
 * 주소에는 기본(최신순)이 아닐 때만 `sort=` 로 남긴다.
 */
export type ContentSort = 'latest' | 'views' | 'likes' | 'comments';

export const CONTENT_SORT_DEFAULT: ContentSort = 'latest';

export const CONTENT_SORT_OPTIONS: SortOption<ContentSort>[] = [
    { name: '최신순', value: 'latest' },
    { name: '조회 많은순', value: 'views' },
    { name: '좋아요 많은순', value: 'likes' },
    { name: '댓글 많은순', value: 'comments' },
];

/** 주소의 정렬 값 — 모르는 값은 최신순 */
export const parseContentSort = (raw: string | null): ContentSort =>
    CONTENT_SORT_OPTIONS.find((option: SortOption<ContentSort>) => option.value === raw)?.value ?? CONTENT_SORT_DEFAULT;
